/* eslint-disable no-console */
import {Col, Form, Select} from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import React, {useContext, useEffect, useMemo, useState} from 'react';

import {ReactComponent as YearCalender} from '../../assets/yearCalender.svg';
import {CommonErrors, TF} from '../../constants/Common';
import FilteredUnit from '../../constants/FilteredUnit';
// import SelectedCountryContext from '../../pages/configurator/orgFacility/Constants/SelectedCountryContext';
import SelectedCountryContext from '../../pages/configurator/orgFacility/Constants/SelectedCountryContext';
import {sortYearOptions} from '../../pages/orgManager/Utils/InfraStructureProfile/constant/sorYear';
import yearFilterArray from '../../shared/YearFilterArray';
import useCompanyStore from '../../store/companyStore/companyDetailsStore';
import useJSONStore from '../../store/StaticJson/jsonStore';
import useUserStore from '../../store/userStore/userStore';
import {hasUserRole, UserRole} from '../../utils/commonFunctions';
import SelectWithOtherOption from '../CustomInputs/Select/SelectWithOtherOption';
import {MYConfig, MYData} from '../MonthlyYearly/Interface/common';
import MonthlyYearlyDrawerForm from '../MonthlyYearly/MonthlyYearlyDrawerForm';

import {facilityKeyLabel, yearKeyLabel} from './Constants/IP/commonKeyLabel';
import {WaterKey, WaterLabel, WaterTooltip} from './Constants/IP/WaterKeyLabel';
import {filterSelectOptions} from './Utils/commonFunctions';

const WaterForm: React.FC<{
  currentStep?: number;
  defaultDisplayStep?: boolean;
}> = ({currentStep, defaultDisplayStep = false}) => {
  const isCompanyUserOrAdmin =
    hasUserRole(UserRole.Company_Admin) || hasUserRole(UserRole.Company_user);
  const [formSelectedCountry, setFormSelectedCountry] = useState<string>('');
  const userDetails = useUserStore.getState().userDetails;
  const WaterSource = useJSONStore.getState().waterSource;
  const {facilityId, selectedYear, selectedCountry} = useContext(
    SelectedCountryContext
  );
  const facilityDetails = useCompanyStore.getState().facilityDetails;
  const [facilityOpt, setFacilityOpt] = useState<any[]>([]);

  const {getFieldValue, setFields} = useFormInstance();

  useEffect(() => {
    setFacilityOpt(
      facilityDetails?.[
        getFieldValue(yearKeyLabel.key) ?? selectedYear ?? ''
      ]?.filter((item: any) => {
        return !item.isLeased;
      }) ?? []
    );
  }, []);

  useEffect(() => {
    setFormSelectedCountry(
      facilityOpt?.find((item: any) => {
        return (
          item?._id === (getFieldValue(facilityKeyLabel.key) ?? facilityId)
        );
      })?.country
    );
  }, [facilityOpt]);

  const [yearOptions, setYearOptions] = useState<any[]>([]);

  useEffect(() => {
    setYearOptions(
      yearFilterArray(
        facilityDetails,
        !isCompanyUserOrAdmin ? userDetails?.facility : undefined,
        false
      )
    );
  }, []);

  const monYear: MYConfig[] = useMemo(() => {
    return [
      {
        mainTitle: {
          key: WaterKey.WATER_WITHDRAWN_TF,
          title: WaterLabel.WATER_WITHDRAWN_TF,
          tooltip: WaterTooltip.WATER_WITHDRAWN_TF
        },
        unit: FilteredUnit(formSelectedCountry ?? selectedCountry)?.volume
          .liquid
      },
      {
        mainTitle: {
          key: WaterKey.WATER_CONSUMED_TF,
          title: WaterLabel.WATER_CONSUMED_TF,
          tooltip: WaterTooltip.WATER_CONSUMED_TF
        },
        unit: FilteredUnit(formSelectedCountry ?? selectedCountry)?.volume
          .liquid
      },
      {
        mainTitle: {
          key: WaterKey.WATER_COST_TF,
          title: WaterLabel.WATER_COST_TF
        },
        unit: FilteredUnit(formSelectedCountry ?? selectedCountry).currency
      }
    ];
  }, [selectedCountry, formSelectedCountry]);

  return (
    <>
      {(currentStep === 0 || defaultDisplayStep) && (
        <>
          <Col className="gutter-row">
            <Form.Item
              name={yearKeyLabel.key}
              label={yearKeyLabel.label}
              hidden={defaultDisplayStep}
              labelCol={{span: 24}}
              initialValue={selectedYear}
            >
              <Select
                placeholder={yearKeyLabel.label}
                options={sortYearOptions(yearOptions)}
                suffixIcon={<YearCalender />}
                disabled={getFieldValue('_id') !== undefined}
                onChange={(e) => {
                  setFacilityOpt(
                    facilityDetails?.[e]?.filter((item: any) => {
                      return !item.isLeased;
                    }) ?? []
                  );
                  if (getFieldValue(facilityKeyLabel.key)) {
                    setFields([
                      {
                        name: facilityKeyLabel.key,
                        value: undefined,
                        errors: ['Please select facility again']
                      }
                    ]);
                  }
                }}
              />
            </Form.Item>
          </Col>
          {isCompanyUserOrAdmin && (
            <>
              <Col className="gutter-row">
                <Form.Item
                  name={facilityKeyLabel.key}
                  label={facilityKeyLabel.label}
                  hidden={defaultDisplayStep}
                  labelCol={{span: 24}}
                  rules={[
                    {
                      required: true,
                      message: CommonErrors.mandatory(facilityKeyLabel.label)
                    }
                  ]}
                  initialValue={facilityId}
                >
                  <Select
                    placeholder={facilityKeyLabel.label}
                    options={
                      facilityOpt?.map((item: any) => {
                        return {label: item.name, value: item._id};
                      }) ?? []
                    }
                    disabled={getFieldValue('_id') !== undefined}
                    onChange={(e) => {
                      setFormSelectedCountry(
                        facilityDetails?.[
                          getFieldValue(yearKeyLabel.key) ?? ''
                        ]?.find((item: any) => {
                          return item?._id === e;
                        })?.country
                      );
                    }}
                  />
                </Form.Item>
              </Col>
            </>
          )}
        </>
      )}
      {(currentStep === 1 || defaultDisplayStep) && (
        <>
          <Col className="gutter-row">
            <Form.Item
              name={WaterKey.WATER_SOURCE}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(WaterLabel.WATER_SOURCE)
                }
              ]}
              label={WaterLabel.WATER_SOURCE}
              labelCol={{span: 24}}
              validateFirst
              hasFeedback
            >
              <SelectWithOtherOption
                showSearch
                filterOption={filterSelectOptions}
                className="select"
                placeholder={`Choose ${WaterLabel.WATER_SOURCE}`}
                options={WaterSource}
              />
            </Form.Item>
          </Col>
        </>
      )}
      {(currentStep === 2 || defaultDisplayStep) && (
        <>
          <MonthlyYearlyDrawerForm
            config={monYear}
            data={getFieldValue(TF) as MYData[]}
          />
        </>
      )}
    </>
  );
};

export default WaterForm;
